import { useEffect, useState } from "react";
import ProductCard, { Product } from "../components/ProductCard";
import Seo from "../components/Seo";
import { api } from "../lib/api";
import { Currency } from "../lib/currency";
import { sampleProducts } from "./_shared";

export default function Products({ currency }: { currency: Currency }) {
  const [products, setProducts] = useState<Product[]>(sampleProducts);
  useEffect(() => { api<Product[]>("/api/products").then((rows) => { if (rows.length) setProducts(rows); }).catch(() => undefined); }, []);
  return (
    <>
      <Seo title="Products" description="Browse SellerSupply Shop products across travel, workspace, electronics, and smart lifestyle categories." image={products[0]?.image} />
      <section className="container-page py-8">
        <div className="mb-8 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div><p className="text-sm font-bold uppercase tracking-[0.18em] text-[#C89B5C]">SellerSupply Shop</p><h1 className="mt-2 text-4xl font-black">Products</h1></div>
          <input className="input max-w-sm" placeholder="Search products" />
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">{products.map((p) => <ProductCard key={p.id} product={p} currency={currency} />)}</div>
      </section>
    </>
  );
}
